import firebase from 'firebase/app'
import router from '@/router'

// Resolve where to send the user after a successful sign-in.
//
// Honors ?redirect=<path> on the current route (e.g. /login?redirect=/daemon/link?port=19385)
// so deep-link flows like the etax-foxpro CLI pair page can bounce back to
// the page that asked for auth. Falls back to /companies-list.
//
// Guard against open-redirect: only accept same-origin paths starting with
// a single slash. Reject '//evil.com', 'http://evil.com', javascript:..., etc.
function resolvePostLoginPath() {
  const fallback = '/companies-list'
  try {
    // Vue Router decodes query values already, so raw is already the
    // intended path string (e.g. "/daemon/link?port=19385").
    const raw = router.currentRoute && router.currentRoute.query && router.currentRoute.query.redirect
    if (!raw || typeof raw !== 'string') return fallback
    if (!raw.startsWith('/')) return fallback
    if (raw.startsWith('//'))  return fallback
    return raw
  } catch (e) {
    return fallback
  }
}

// Stamp last login on the user's Users doc for active/inactive tracking.
// Best-effort: a write failure must never block sign-in.
function stampLastLogin(user) {
  if (!user) return
  firebase
    .firestore()
    .collection('Users')
    .doc(user.uid)
    .set({ lastLoginAt: firebase.firestore.FieldValue.serverTimestamp() }, { merge: true })
    .catch(() => {})
}

export default {
  namespaced: true,
  state: {
    status: ""
  },
  mutations: {},
  actions: {
    login({ dispatch }, { email, password }) {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((cred) => {
          stampLastLogin(cred.user)
          dispatch('user/getPageLimit', {}, { root: true })
          router.push(resolvePostLoginPath())
        })
        .catch(() => {
          alert("Email or password is invalid.")
        })
    },
    signInWithToken({ dispatch }, { token }) {
      firebase
        .auth()
        .signInWithCustomToken(token)
        .then((cred) => {
          stampLastLogin(cred.user)
          dispatch('user/getPageLimit', {}, { root: true })
          router.push(resolvePostLoginPath())
        })
        .catch((err) => {
          alert('Sign in with token ' + err)
        })
    },
    logout({ commit }) {
      // Clear user data from Vuex store before signing out
      commit('user/clearUserData', null, { root: true });

      firebase
        .auth()
        .signOut()
        .then(() => {
          if(router.currentRoute.name === "Login"){
            window.location.reload()
          }else router.push('/login')
        })
        .catch(() => {
          alert("error")
        })
    },
    logoutWithoutRedirect({ commit }) {
      // Clear user data from Vuex store before signing out
      commit('user/clearUserData', null, { root: true });

      firebase
        .auth()
        .signOut()
        .then(() => {
        })
        .catch(() => {
          alert("error")
        })
    }
  },
  modules: {}
}
